import {Item} from "./types";
import {INITIAL_DATA} from "./constants";

export const getItemData = (item: Item): { [key: string]: string } => {
  switch (item?.__typename) {
    case "Application":
      return {
        id: item.id,
        name: item.name,
        entityName: "приложения",
      };

    case "ApplicationMain":
      return {
        id: item.id,
        name: item.name,
        entityName: "страницы приложения",
      };

    case "ApplicationMainModel":
      return {
        id: item.id,
        name: item.name,
        entityName: "модели",
      };

    case "MobileNotification":
      return {
        id: item.id,
        name: item.name,
        entityName: "уведомления",
      };

    default:
      return INITIAL_DATA;
  }
};
